const attribution = require('./marketingAttribution');

function clientSource(client) {
  const profile = client?.client_profile || {};
  const source = profile.acquisition_source;
  const legacy = profile.origin || (client?.mortgages || []).find(m => m.poznamka_k_prvej_analyze)?.poznamka_k_prvej_analyze;
  const raw = source?.landing_page || legacy || '';
  let href = null;
  try {
    const url = new URL(raw);
    if (['http:', 'https:'].includes(url.protocol)) href = url.href;
  } catch (_) { /* Older records may contain a description instead of a URL. */ }
  if (source?.channel === 'google_ads') {
    return {href, label: 'Google Ads' + (source.campaign_id ? ' • ' + source.campaign_id : ''), className: 'source-ads'};
  }
  const channels = {
    organic: {label: 'Organika', className: 'source-organika'},
    paid_other: {label: 'Platená návštevnosť', className: 'source-ads'},
    referral: {label: 'Odporúčanie', className: 'source-dev'},
  };
  return {href, ...(channels[source?.channel] || attribution.classify(legacy || raw))};
}

module.exports = clientSource;
